import * as React from 'react';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import * as Web from "./Web";
import { ErrorAlert, IErrorInfo } from './ErrorAlert';

export interface UserPageProps  {
   companyId: number
};

export interface User {
   id?: number,
   guid?: string,
   wpid?: number,
   email?: string,
   name?: string,
   companyId?: number,
   accessLevel?: number,
   status?: number,
};

export const UsersPage = () => {
   const [users, setUsers] = React.useState<User[]>([]);
   const [start, setStart] = React.useState(0);
   const [count, setCount] = React.useState(10);
   const [doFetch, setDoFetch] = React.useState(false);
   const [error, setError] = React.useState<IErrorInfo | null>(null);

   React.useEffect(() => {
      let controller = new AbortController();
      if (doFetch) {
         fetch();
      }
      async function fetch() {
         const response = await Web.httpGet(`api/user?start=${start}&count=${count}`, controller);
         if (response?.errorCode) {
            setUsers([]);
            setError(response);
         }
         else {
            setUsers(response?.result);
            setError(null);
         }

         console.log(response?.result);
         setDoFetch(false);
      }
      return function cleanup() {
         controller.abort();
      };
   }, [start, count, doFetch]);

   console.log(users);
    return (
      <Container sx={{ mt: 10 }}>
         {(error) ? <ErrorAlert {...error} /> : undefined}
         <Box sx={{ mb: 14 }} >
            <Typography variant="h4">{"users.title"}</Typography>
            <Typography variant="body1">{"users.description"}</Typography>
         </Box>

         <Box sx={{ mb: 14, flexGrow: 1, display: 'flex' }}>
            <TextField
               label={"users.start"}
               variant="outlined"
                    slotProps={{
                        htmlInput: {
                            inputMode: 'numeric',
                            pattern: '[0-9]*'
                        },
                    }}
               value={start}
               onChange={(e) => setStart(Number(e.target.value))}
               sx={{ mr: 10 }}
            />
            <TextField
               label={"users.count"}
               variant="outlined"
                    slotProps={{
                        htmlInput: {
                            inputMode: 'numeric',
                            pattern: '[0-9]*'
                        },
                    }}
               value={count}
               onChange={(e) => setCount(Number(e.target.value))}
               sx={{ mr: 10 }}
            />
            <Button
               variant="contained"
               onClick={() => setDoFetch(true)}
               disabled={doFetch}
            >
               Update
            </Button>
         </Box>

         <TableContainer component={Paper}>
            <Table>
               <TableHead>
                     <TableRow>
                        <TableCell><Typography variant="bold">placeholder</Typography></TableCell>
                        <TableCell><Typography variant="bold">placeholder</Typography></TableCell>
                        <TableCell><Typography variant="bold">placeholder</Typography></TableCell>
                     </TableRow>
               </TableHead>
               <TableBody>
                  {users.map(user =>
                     <TableRow key={user.id}>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.accessLevel}</TableCell>
                     </TableRow>
                  )}
               </TableBody>
            </Table>
         </TableContainer>
      </Container>
   );
}

export default UsersPage;